export default "__VITE_ASSET__BUqLGivP__"